module.exports = __webpack_public_path__ + "static/product1-a-c4d58f361d70acda6486af3335056a26.png";